import { Controller } from "@hotwired/stimulus"

// Radio-driven guardian picker for household review.
// 3 modes: existing (search + pick), new (create inline), cancel.
// Also handles the search-as-you-type fetch for the existing path.
export default class extends Controller {
  static targets = [
    "modeRadio",
    "existingSection",
    "newSection",
    "searchInput",
    "searchResults",
    "guardianIdInput",
    "existingSubmit"
  ]

  static values = {
    searchUrl: String
  }

  connect() {
    this.updateVisibility()
  }

  modeChanged() {
    this.updateVisibility()
  }

  updateVisibility() {
    const mode = this.selectedMode()
    this.existingSectionTarget.classList.toggle("hidden", mode !== "existing")
    this.newSectionTarget.classList.toggle("hidden", mode !== "new")
  }

  selectedMode() {
    const checked = this.modeRadioTargets.find((r) => r.checked)
    return checked ? checked.value : "existing"
  }

  async search() {
    const q = this.searchInputTarget.value.trim()
    if (q.length < 2) {
      this.searchResultsTarget.innerHTML = ""
      return
    }
    // The searchUrlValue from the Rails helper already carries query params
    // (account_context=...), so use URL/URLSearchParams to merge q correctly.
    const url = new URL(this.searchUrlValue, window.location.origin)
    url.searchParams.set("q", q)
    try {
      const resp = await fetch(url.toString(), { headers: { Accept: "application/json" } })
      if (!resp.ok) return
      const data = await resp.json()
      this.renderResults(data.results || [])
    } catch (_e) {
      // silent
    }
  }

  renderResults(results) {
    if (!results.length) {
      this.searchResultsTarget.innerHTML = `<div class="p-3 text-sm text-gray-500">No matches</div>`
      return
    }
    this.searchResultsTarget.innerHTML = results
      .map(
        (r) => `
          <button type="button"
            data-action="click->guardian-picker#pickResult"
            data-guardian-id="${r.id}"
            data-guardian-label="${this.escape(r.label)}"
            class="w-full text-left p-3 border-b hover:bg-gray-50"
            style="border-color: #e5e7eb;">
            <div class="font-medium" style="color: #111827;">${this.escape(r.label)} <span class="text-xs text-gray-500">row #${r.row}</span></div>
            <div class="text-xs" style="color: #6b7280;">${this.escape(r.detail || "—")}</div>
          </button>`
      )
      .join("")
  }

  pickResult(event) {
    const btn = event.currentTarget
    this.guardianIdInputTarget.value = btn.dataset.guardianId
    this.searchInputTarget.value = btn.dataset.guardianLabel
    this.searchResultsTarget.innerHTML = ""
    this.existingSubmitTarget.disabled = false
  }

  escape(str) {
    const div = document.createElement("div")
    div.textContent = str || ""
    return div.innerHTML
  }
}
